<template>
  <div class="clearfix common-body-box">
    <nav-header></nav-header>
    <div>
      <slot name="swiper">
        <div class="common-swiper-box">
          <!-- <img src="../../public/images/4.jpg" alt=""> -->
        </div>
      </slot>
    </div>
    <div class="common-body-content">
      <div class="common-body-content-box">
        <slot></slot>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import NavHeader from "@/components/navHeader.vue";
import Footer from "@/components/footer.vue";
export default {
  name: "CommonBody",
  components: {
    NavHeader,
    Footer,
  },
  data() {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
.common-body-box {
  height: 100%;
  width: 100%;

  .common-swiper-box {
    width: 100%;
    height: 400px;
    background: url('../../public/images/bg.png') no-repeat;
    background-size: cover;
    img {
      width: 100%;
      max-height: 650px;
    }
  }
  .common-body-content {
    max-width: 100%;
    // min-height: calc(100% - 200px);
    margin: 0 auto;
    padding-top: 50px;

    .common-body-content-box {
      width: 100%;
      margin: 0 auto;
    }
  }
  .home-content-box{
    width: 100%;
  }
}
</style>
<style lang="scss">
.common-body-box {
  .swiper-pagination-bullet {
    width: 20px;
    border-radius: 5px;
    background: rgba(71, 1, 37, .9);
  }
 .swiper-pagination-bullet-active {
    width: 25px;
    background: #470125;
  }
}
</style>